var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_1a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg_2b",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 0H0v40h40z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg_2b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 20q0 .875-.5625 1.4375C34.875 22 34.5833 22 34 22H14v4.5q-.0625.9375-.875 1.375-.9375.375-1.625-.25l-7-6.5Q4 20.625 4 20t.5-1.125l7-6.5q.6875-.625 1.625-.25.8125.4376.875 1.3125V18h20q.875 0 1.4375.5625C36 19.125 36 19.4167 36 20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.204e3e473bb8a422625f1e30dee3a132.svg";